import {
	allows,
	PermissionMatrixName,
} from '@netx/core-permissions/utils/allows';
import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {type IAsset} from '../schema';

export const canOrganizeAsset = (asset?: IAsset) =>
	asset != null &&
	!isBrandPortal() &&
	currentUserMeetsUserLevel(UserLevel.MANAGER) &&
	allows(asset.permissionMatrix, PermissionMatrixName.MODIFY);

export default canOrganizeAsset;
